import React from 'react'
import ReactDOM from 'react-dom'
// Templates
import Note from './templates/Note'

export default function PartOfSpeech() {
  const mainText = `
    動画内容とあわせてレジュメをご確認ください。
  `
  const textList = [
    {
      text: '●「品詞判別」レジュメ （品詞判別トレーニング動画用）',
      fileName: '品詞判別レジュメ_STRAIL'
    },
  ]

  return (
    <Note
      mainText={mainText}
      textList={textList}
    />
  )
}

if (document.getElementById('partofspeech_training')) {
  ReactDOM.render(
    <PartOfSpeech />,
    document.getElementById('partofspeech_training')
  )
}